<ng-container [formGroup]="form()">
    <div class="w-full flex gap-[35px]">
      <lib-form-dropdown class="w-1/2"
          label="How many owners are active in the field?"
          [manualOptions]="fieldOwnerOptions"
          formControlName="numberOfFieldOwners">
      </lib-form-dropdown>
      <!-- Calculated from the number of field owners, so it's display-only -->
      <div class="w-1/2">
        <p class="semi-bold mb-0">Owner Payroll</p>
        <p class="mb-0">{{ wizardStore.ownerPayroll() | currency:'USD':'symbol':'1.0-0' }}</p>
      </div>
    </div>
    <div class="w-full flex gap-[35px]">
      <lib-form-dropdown class="w-1/2"
          label="How many employees does the applicant have?"
          [manualOptions]="employeeOptions"
          formControlName="numberOfEmployees">
      </lib-form-dropdown>
      <!-- "Must be greater than $0 when there are employees" is shown by the control's validator -->
      <lib-form-money class="w-1/2" label="Employee Payroll" formControlName="employeePayroll"></lib-form-money>
    </div>

    <!-- Step 2 puts its subcontractor costs here, between the payroll and the classes -->
    <ng-content></ng-content>

    <div class="w-full flex flex-col" formArrayName="classes">

        <!-- If you track index rather than class, as suggested by error NG0956, it breaks how the classes get added/removed form the array. -->
        @for (class of classesFormArray.controls; track class; let i = $index) {
            <div class="w-full flex gap-[35px]" [formGroupName]="i">

              <lib-form-dropdown
                class="w-1/2"
                [label]="i === 0 ? 'Applicant\'s Primary Classification' : 'Additional Classification'"
                [options]="lookupStore.programClasses()!"
                formControlName="classCode">
              </lib-form-dropdown>


              @if (i > 0) {
                <div class="custom-padding-class"> <!-- add your padding class here -->
                  <mat-form-field class="w-full">
                    <mat-label>Percentage of work</mat-label>
                    <input matInput type="number" formControlName="percentageOfWork" min="1" max="100" step="1"
                      onkeydown="return event.key !== '.' && event.key !== 'e' && event.key !== 'E' && event.key !== '+' && event.key !== '-'" />
                    <span matTextSuffix>%</span>
                    <mat-error>{{ class.get('percentageOfWork')?.hasError('required') ? 'Required' : 'Enter a percentage from 1 to 100' }}</mat-error>
                  </mat-form-field>

                  <a
                    class="w-4 pl-5 flex justify-center items-center cursor-pointer"
                    (click)="removeClass(i)">
                    <lib-icon icon="close" class="w-4"></lib-icon>
                  </a>
                </div>
              } @else {
                <mat-form-field class="w-1/2">
                  <mat-label>Percentage of work</mat-label>
                  <input matInput type="number" formControlName="percentageOfWork" min="1" max="100" step="1"
                    onkeydown="return event.key !== '.' && event.key !== 'e' && event.key !== 'E' && event.key !== '+' && event.key !== '-'" />
                  <span matTextSuffix>%</span>
                  <mat-error>{{ class.get('percentageOfWork')?.hasError('required') ? 'Required' : 'Enter a percentage from 1 to 100' }}</mat-error>
                </mat-form-field>
              }

            </div>
          }
    </div>

    <div class="w-full flex gap-[35px]">
        <div class="w-1/2">
          @if (showTotalPayroll()) {
            <p class="large">
                <span class="font-semibold">
                    Total Payroll:
                </span>
                <span class="ml-1">
                    {{ wizardStore.totalPayroll() | currency }}
                </span>
            </p>
            @if(wizardStore.totalPayroll() < 20000 && wizardStore.totalPayroll() !== 0) {
              <p class="text-red">
                  Error: Minimum Payroll is $20,000
              </p>
            } @else if (wizardStore.duplicateClasses()) {
              <p class="text-red">
                Error: Duplicate classes present, remove duplicate. Add additional payroll to the first entry for each class.
              </p>
            }
          }
        </div>
        <!-- Total of the classes' percentage of work; hidden until a percentage is filled in -->
        @if (wizardStore.totalClassPercentage() > 0) {
          <div class="w-1/2">
            <p class="large font-semibold mb-0">{{ wizardStore.totalClassPercentage() }}%</p>
            @if (wizardStore.totalClassPercentage() !== 100) {
              <p class="text-red">Must equal 100%</p>
            }
          </div>
        }
    </div>
    <div class="py-4">
        <lib-button [cssType]="'btn-link'"  [text]="'Add Classification'" [icon]="'circleplus'"  [buttonType]="'button'"  (click)="addClass()"></lib-button>
    </div>
</ng-container>
